"use client"

import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { usePathname, useRouter } from 'next/navigation';
import { get_locale_direction } from "@core/helpers/locale-rules";
import { set_cookie_client } from "../cookie";

export const LanguageContext = createContext(false)

export const LanguageContextProvider = ({ children, current_locate, current_direction, locates = [] }) => {

	const route = useRouter();
	const pathname = usePathname();

	const [language, set_language] = useState(() => {
		return current_locate;
	});

	const available_languages = useMemo(() => locates, [locates]);
	// every right-to-left language (ar was missing from locates-direction.json), the server's value for anything else
	const direction = useMemo(() => get_locale_direction(language, current_direction), [current_direction, language])

	const change_language = useCallback((lang) => {
		if (lang === available_languages?.[0] && available_languages?.includes(lang)) {
			set_cookie_client("locale", lang);

			setTimeout(() => {
				window.location = "/"
			}, 100);
			
			// return route.push("/");
		} else {
			set_cookie_client("locale", lang);

			setTimeout(() => {
				window.location = `/${lang}`
			}, 100);

			// return route.push(`/${lang}`);
		}
	}, [available_languages]);

	const home_page_pathname = useMemo(() => {
		if (language === available_languages?.[0]) {
			return "/"
		} else {
			return `/${language}`
		}
	}, [available_languages, language]);


	useMemo(() => {
		const pathname_lang = pathname?.split("/")?.filter(item => item?.length)?.[0];

		let detect_lang = available_languages?.[0];
		if (available_languages?.includes(pathname_lang)) {
			detect_lang = pathname_lang;
		}

		if (language !== detect_lang) {
			set_language(detect_lang)
		}
	}, [pathname, available_languages, language]);

	useMemo(() => {
		if (typeof document !== "undefined" && language) {
			const htmlElement = document?.getElementById('html-tag')
			if (htmlElement) {
				htmlElement?.setAttribute('lang', language);
				if (direction) htmlElement?.setAttribute('dir', direction);
			}
		}
	}, [language, direction]);

	const values = useMemo(
		() => ({
			language,
			set_language,
			direction,
			available_languages,
			change_language,
			home_page_pathname,
		}),
		[
			language,
			direction,
			available_languages
		]
	);

	return (
		<LanguageContext.Provider value={{ ...values }}>
			{children}
		</LanguageContext.Provider>
	);
};

export const useLanguageContext = () => useContext(LanguageContext);